"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaPath = schemaPath;
function schemaPath(obj, typeonly) {
    const key = obj.$key;
    if (obj.$parent) {
        let res = schemaPath(obj.$parent, typeonly);
        if (obj.$parent && obj.$parent.type === 'array') {
            res += '[]';
        }
        if (typeonly &&
            (obj.type === undefined || (obj.type === 'object' && obj.$parent && obj.$parent.type === 'array'))) {
            return res;
        }
        if (res === '') {
            return key;
        }
        else {
            return res + '.' + key;
        }
    }
    else {
        if (typeonly && obj.type === undefined) {
            return '';
        }
        if (key) {
            return key;
        }
        else {
            return '';
        }
    }
}
exports.default = schemaPath;
//# sourceMappingURL=schemaPath.js.map